import React from 'react';
import classnames from 'classnames';
import { hot } from 'react-hot-loader/root';

import './SkipLinks.scss';

export class SkipLinks extends React.PureComponent {
  state = {
    hasFocus: false,
  };

  buttonRef = React.createRef();

  onControlFocus = () => {
    this.setState({
      hasFocus: true,
    });
  };

  onControlBlur = () => {
    this.setState({
      hasFocus: false,
    });
  };

  onSkipClick = (event) => {
    // because certain containers are not focusable, we place 'skip-link' buttons around to accept the focus
    // they are hidden by default to avoid invisible tab items, but temporarily shown so skip links work
    event.currentTarget.blur();

    const targets = document.getElementsByTagName('main');

    // we haven't made the jump consistent enough
    if (targets.length === 0) {
      return;
    }

    // make it tabbable
    const target = targets[0];
    target.tabIndex = 0;
    target.focus();
  };

  onKeyUp = (event) => {
    // escape button was pressed
    if (event.keyCode === 27) {
      // shift focus to button (last element) so when user presses tab SkipLinks doesn't reappear
      this.buttonRef.current.focus();
      this.buttonRef.current.blur();
    }
  };

  render() {
    const { hasFocus } = this.state;
    const className = classnames({
      active: hasFocus,
    });

    return (
      <skip-links class={className}>
        <button
          className="skip-button"
          type="button"
          ref={this.buttonRef}
          onFocus={this.onControlFocus}
          onBlur={this.onControlBlur}
          onKeyUp={this.onKeyUp}
          onClick={this.onSkipClick}
        >
          Skip to main content
        </button>
      </skip-links>
    );
  }
}

export const HotSkipLinks = hot(SkipLinks);
